import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return <Navigate to="/signin" replace state={{ from: location }} />;

  const isVerified = Boolean(user.emailVerified);
  const isApproved = user.approvalStatus === 'approved';

  if (!isVerified || !isApproved) {
    return <Navigate to="/account-status" replace />;
  }

  if (location.pathname === '/employees' && user.role === 'store') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;


